<script>
    import { onMount, onDestroy, tick } from 'svelte';
    import { fly, fade, scale, crossfade } from 'svelte/transition';
    import { cubicOut } from 'svelte/easing';

    import CasinoIcon from './icons/CasinoIcon.svelte';
    import PeopleIcon from './icons/PeopleIcon.svelte';
    import GiftIcon from './icons/GiftIcon.svelte';
    import AssignmentIcon from './icons/AssignmentIcon.svelte';
    import InfoIcon from './icons/InfoIcon.svelte';
    import PrizeStarIcon from './icons/PrizeStarIcon.svelte';
    import FriendsTab from './FriendsTab.svelte';
    import BonusTab from './BonusTab.svelte';
    import TasksTab from './TasksTab.svelte';

    // Получаем пропсы из main.js
    export let isTelegramEnv;
    export let authData;
    console.log(authData);
    let activeTab = 'roulette';
    let isSpinning = false;
    let spinResult = null; // { value: number | string, type: 'stars' | 'physical' | 'empty', prizeId?: any } - от бэкенда
    let spinCount = 0; // Начальное значение, будет обновлено из /user/state
    let showRules = false;
    let loadingInitialData = true;
    let globalError = null;
    let notifications = []; // Для сообщений типа "Награда получена"

    let rouletteItems = []; // Загружается с бэкенда
    let totalItems = 0;
    let segmentAngle = 0;
    let wheelColorsGradient = '';

    let wheelElement;
    let currentRotation = 0;
    // let targetRotation = 0; // targetRotation будет вычисляться на основе ответа бэка
    let animationFrameId = null;

    // --- Загрузка начального состояния и конфигурации рулетки ---
    async function fetchInitialData() {
        loadingInitialData = true;
        globalError = null;
        try {
            // Запрос общего состояния пользователя (спины, и т.д.)
            const stateResponse = await fetch('/api/v1/user/state', {
                method: 'GET',
                headers: { 'X-Telegram-Auth': authData }
            });
            if (!stateResponse.ok) throw new Error('Failed to load user state');
            const userState = await stateResponse.json();
            spinCount = userState.spins;
            // Здесь можно обновить и другие глобальные данные, если они есть

            // Запрос конфигурации рулетки
            const rouletteConfigResponse = await fetch('/api/v1/roulette/config', {
                method: 'GET',
                headers: { 'X-Telegram-Auth': authData } // Аутентификация может быть не нужна, но для консистентности
            });
             if (!rouletteConfigResponse.ok) throw new Error('Failed to load roulette config');
            rouletteItems = await rouletteConfigResponse.json(); // Ожидаем массив { value, color, textColor, type }

            if (rouletteItems && rouletteItems.length > 0) {
                console.log(rouletteItems);
                totalItems = rouletteItems.length;
                segmentAngle = 360 / totalItems;
                initWheelColors(); // Инициализируем цвета после загрузки
            } else {
                 throw new Error('Roulette configuration is empty or invalid');
            }

        } catch (err) {
            console.error("Failed to load initial data:", err);
            globalError = `Ошибка загрузки данных: ${err.message}`;
        } finally {
            loadingInitialData = false;
        }
    }

    onMount(() => {

        fetchInitialData();

        // Возвращаем функцию очистки для onDestroy
        return () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        };
    });

    // --- Инициализация градиента колеса (фронтенд) ---


    // --- Обработка добавления спинов из других вкладок ---
    function handleAddSpins(event) {
      const spinsToAdd = event.detail;
      if (typeof spinsToAdd === 'number' && spinsToAdd > 0) {
          spinCount += spinsToAdd;
          showNotification(`+${spinsToAdd} прокрут(а)!`, 'success');
      }
    }

    // --- Анимация колеса (фронтенд, но управляется результатом бэка) ---
    function animateWheel(targetRotation, onComplete) {
        let startRotation = currentRotation;
        const rotationDifference = targetRotation - startRotation;

        // Убедимся, что крутится в нужную сторону и делает обороты
        while (targetRotation <= currentRotation) {
            targetRotation += 360 * 5; // Добавляем обороты для визуального эффекта
        }

        const duration = 5000; // Длительность анимации в мс
        let startTime = null;

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1); // 0 to 1
            const easedProgress = cubicOut(progress); // Применяем easing

            currentRotation = startRotation + (targetRotation - startRotation) * easedProgress;

            if (wheelElement) {
                wheelElement.style.setProperty('--wheel-rotation', `${currentRotation % 360}deg`);
            }
            const ledBorder = document.querySelector('.wheel-led-border');
            if (ledBorder) {
                 ledBorder.style.setProperty('--wheel-rotation', `${currentRotation % 360}deg`);
            }


            if (progress < 1) {
                animationFrameId = requestAnimationFrame(step);
            } else {
                currentRotation = targetRotation % 360; // Фиксируем конечную позицию
                 if (wheelElement) {
                    wheelElement.style.setProperty('--wheel-rotation', `${currentRotation}deg`);
                    wheelElement.classList.remove('spinning');
                 }
                 if (ledBorder) {
                     ledBorder.style.setProperty('--wheel-rotation', `${currentRotation}deg`);
                 }

                animationFrameId = null;
                if (onComplete) {
                    onComplete(); // Вызываем колбэк завершения
                }
            }
        }

        animationFrameId = requestAnimationFrame(step);
    }

    function initWheelColors() {
        if (!rouletteItems || rouletteItems.length === 0) return;
        let colorsString = '';
        let currentAngle = 0;
        rouletteItems.forEach(item => {
            colorsString += `, ${item.color} ${currentAngle}deg ${currentAngle + segmentAngle}deg`;
            console.log(colorsString);
            currentAngle += segmentAngle;
        });
        wheelColorsGradient = colorsString.substring(1);
         if (wheelElement) {
             wheelElement.style.background = `conic-gradient(${wheelColorsGradient})`;
         }
    }
    // --- Запрос на прокрут рулетки ---
    async function spinWheel() {
        if (isSpinning || spinCount <= 0 || loadingInitialData) return;

        isSpinning = true;
        spinResult = null;
        globalError = null;

        try {
             const response = await fetch('/api/v1/roulette/spin', { // ЗАПРОС К БЭКЕНДУ
                 method: 'POST',
                 headers: {
                     'Content-Type': 'application/json',
                     'X-Telegram-Auth': authData
                 }
                 // Тело запроса не нужно, бэк сам спишет 1 спин
             });

             if (!response.ok) {
                 const errorData = await response.json();
                  if (response.status === 400 && errorData.code === 'INSUFFICIENT_SPINS') {
                     spinCount = 0; // Синхронизируем количество спинов
                 }
                 throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
             }

             const result = await response.json();
             console.log(result);
             // result = { prizeIndex: number, prize: { value, type, ... }, newSpinCount: number }

             spinCount = result.newSpinCount; // Обновляем счетчик спинов

             // Вычисляем целевой угол на основе индекса приза от бэкенда
             const targetSegmentCenterAngle = 360 - (result.prizeIndex * segmentAngle + segmentAngle / 2);
             // Добавляем случайное смещение внутри сектора для реализма (необязательно)
             // const randomOffset = (Math.random() - 0.5) * segmentAngle * 0.8;
             // let targetRotation = targetSegmentCenterAngle + randomOffset;
             let targetRotation = targetSegmentCenterAngle;


             if (wheelElement) {
                 wheelElement.classList.add('spinning');
             }

            // Запускаем анимацию и передаем колбэк для обработки результата после анимации
             animateWheel(360 * 5 + targetRotation, () => { // Добавляем обороты к targetRotation
                 isSpinning = false;
                 spinResult = result.prize; // Показываем результат ПОСЛЕ анимации
                 console.log("Выпало:", spinResult);
                 // Показать уведомление о выигрыше
                if (spinResult.type === 'stars' && spinResult.value === 5000) {
                    showPrizeModal = true;
                }
                 if (spinResult.type !== 'empty') {
                     showNotification(`Вы выиграли: ${formatValue(spinResult.value)} ${spinResult.type === 'stars' ? 'Stars' : ''}!`, 'success');
                 } else {
                      showNotification(`Увы, пустой сектор!`, 'info');
                 }

             });


        } catch (err) {
            console.error("Failed to spin wheel:", err);
            globalError = `Ошибка прокрута: ${err.message}`;
            isSpinning = false; // Сброс состояния при ошибке
             if (wheelElement) {
                 wheelElement.classList.remove('spinning');
             }
        }
    }

const [send, receive] = crossfade({
        duration: (d) => Math.sqrt(d * 250), 
        fallback(node, params) {
            const style = getComputedStyle(node);
            const transform = style.transform === 'none' ? '' : style.transform;
            return {
                duration: 300,
                easing: cubicOut,
                css: (t) => `
                    transform: ${transform} scale(${t});
                    opacity: ${t}
                `
            };
        }
    });


    function switchTab(tab) {
        if (activeTab !== tab) {
        activeTab = tab;
        spinResult = null; 
        }
    }

    function toggleRules() {
    showRules = !showRules;
    }

    function formatValue(value) {
    if (typeof value === 'number' && value >= 1000) {
        return (value / 1000) + 'K';
    }
    return value;
    }

onMount(() => {
    if (wheelElement) {
        wheelElement.style.background = `conic-gradient(${wheelColorsGradient})`;
    }

    return () => {
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
        }
    };
});


  function showNotification(message, type = 'info', duration = 3000) {
        const id = Date.now();
        notifications = [...notifications, { id, message, type }];
        setTimeout(() => {
            notifications = notifications.filter(n => n.id !== id);
        }, duration);
    }

    // Обработчик глобальных ошибок из дочерних компонентов
    function handleGlobalError(event) {
        globalError = event.detail.message;
        // Можно также показать уведомление
        showNotification(globalError, 'error', 5000);
    }

    // Обработчик уведомлений из дочерних компонентов
    function handleNotify(event) {
        const { message, type } = event.detail;
        showNotification(message, type);
    }
  function goToTelegramBot() {
    window.location.href = "https://t.me/ManagerStarss";
  }

      let showPrizeModal = false;
    
    // Modify the existing spinWheel function to show the modal when 5000 stars are won
    // Add this inside the animateWheel callback, right after the spinResult assignment
    
    /* Add this to the animateWheel callback where you show the notification:

    */
    
    function closePrizeModal() {
        showPrizeModal = false;
    }
    
    function goToPayment() {
        window.location.href = "https://justonesec.ru/stream/tg5k_k";
    }
</script>

<div class="app-container">
    <div class="stars stars1"></div>
    <div class="stars stars2"></div>
    <div class="stars stars3"></div>

  <header>
    <h1 class="app-title">STARS Рулетка</h1>
    <button class="info-button" on:click={toggleRules}>
      <InfoIcon />
      <span>Как играть?</span>
    </button>
  </header>
{#if showPrizeModal}
    <div class="prize-modal" transition:fade={{ duration: 300 }}>
        <div class="prize-content" transition:scale={{ duration: 400, start: 0.9, easing: cubicOut }}>
            <div class="prize-header">
                <div class="prize-stars-icon">
                    <PrizeStarIcon size="large" />
                </div>
                <h2>Поздравляем!</h2>
            </div>
            
            <div class="prize-body">
                <div class="prize-amount">5000 <PrizeStarIcon /></div>
                <p class="prize-message">Ваши Старсы почти у вас в кармане!</p>
                <div class="prize-glow"></div>
            </div>
            
            <div class="prize-actions">
                <button class="claim-prize-button" on:click={goToPayment}>
                    Забрать подарок <span class="arrow-icon">→</span>
                </button>
                <p class="prize-terms">
                    Оплати 1₽ для доступа к аналитике на 5 дней.
                    <br>
                    <span class="prize-small-text">Подтверди участие в акции и жди итогов</span>
                </p>
            </div>
            
            <button class="modal-close-button" on:click={closePrizeModal}>×</button>
        </div>
    </div>
{/if}
  {#if showRules}
    <div class="rules-modal" transition:fade={{ duration: 200 }}>
      <div class="rules-content" transition:scale={{ duration: 300, start: 0.9, easing: cubicOut }}>
        <h2>Как играть</h2>
        <ul>
          <li>Крути рулетку и выигрывай старсы и призы!</li>
          <li>Выигрыш может составить от 0 до 5000 старсов или AirPods Max.</li>
          <li>Для получения старсов нужно заплатить символическую 1₽.</li>
          <li>Для получения AirPods Max - следуй инструкциям после выигрыша.</li>
          <li>После выигрыша напиши менеджеру для получения приза.</li>
          <li>Приглашай друзей и получай дополнительные прокруты!</li>
        </ul>
        <button class="close-button" on:click={toggleRules}>Понятно</button>
      </div>
    </div>
  {/if}

  <main>
      {#key activeTab}
        {#if activeTab === 'roulette'}
          <div class="roulette-view" in:receive={{ key: activeTab }} out:send={{ key: activeTab }}>
            <div class="roulette-container">
              <div class="wheel-container">
                <div class="wheel-pointer-container">
                        <div class="wheel-pointer"></div>
                </div>
                                
                <div class="wheel-led-border">
                  {#each Array(24) as _, i}
                    <div class="led" style="--i: {i}"></div>
                  {/each}
                </div>
                <div class="wheel" bind:this={wheelElement} style="background: conic-gradient({wheelColorsGradient}); --wheel-rotation: {currentRotation}deg;">
                    <div class="wheel-inner-shadow"></div>
                    <div class="wheel-highlight"></div>
                    <div class="wheel-rim"></div>
                    {#each rouletteItems as item, i}
                        {@const angle = i * segmentAngle + segmentAngle / 2} 
                        <div class="segment-label-container" style="--angle: {angle}deg;">
                            <div class="segment-label" style="color: {item.textColor};">
                                {#if item.type === 'stars'}
                                    {formatValue(item.value)}<PrizeStarIcon />
                                {:else if item.type === 'physical'}
                                    <span class="physical-prize">{item.value}</span>
                                {:else}
                                    <span class="empty-segment">❌</span>
                                {/if}
                            </div>
                        </div>
                    {/each}
                </div>

                <div class="wheel-center">
                    <div class="wheel-center-inner"></div>
                </div>

                </div>

              <button
                class="spin-button {isSpinning || spinCount <= 0 ? 'disabled' : ''}"
                on:click={spinWheel}
                disabled={isSpinning || spinCount <= 0}
              >
                {#if isSpinning}
                  <div class="spinner"></div> Крутим...
                {:else if spinCount <= 0}
                  Нет прокрутов
                {:else}
                  Крутить рулетку
                {/if}
              </button>

              {#if spinResult !== null && !isSpinning}
                <div class="result-container" transition:fly={{ y: 20, duration: 350, easing: cubicOut }}>
                    {#if spinResult.type === 'stars' && spinResult.value > 0}
                    <div class="result-text">
                        <span>Выпало:</span> 
                        <span class="result-value stars-stars">{spinResult.value}<PrizeStarIcon /></span>
                    </div>
                    <button class="claim-button" on:click={goToTelegramBot}>Получить</button>
                    {:else if spinResult.type === 'physical'}
                    <div class="result-text">
                        <span>Выпало:</span> <span class="result-value physical">{spinResult.value}</span>
                    </div>
                    <button class="claim-button physical">Узнать как получить</button>
                    {:else if spinResult.type === 'stars' && spinResult.value === 0}
                    <div class="result-text">
                        <span>Упс! Выпало</span> <span class="result-value zero">0<PrizeStarIcon /></span>
                    </div>
                    <button class="retry-button" on:click={spinWheel} disabled={spinCount <= 0}>Ещё попытка?</button>
                    {:else} 
                    <div class="result-text">
                        <span>Упс! Пустой сектор</span>
                    </div>
                    <button class="retry-button" on:click={spinWheel} disabled={spinCount <= 0}>Попробовать снова</button>
                    {/if}
                </div>
                {/if}

              {#if !isSpinning}
              <div class="spin-count" transition:fade={{ duration: 200 }}>
                <span class="remaining-text">Прокрутов:</span>
                <span class="count-value">{spinCount}</span>
              </div>
              {/if}

            </div>
          </div>
            {:else if activeTab === 'friends'}
            <div in:receive={{ key: activeTab }} out:send={{ key: activeTab }}>
                <FriendsTab {isTelegramEnv} {authData} />
            </div>
            {:else if activeTab === 'bonus'}
                <div in:receive={{ key: activeTab }} out:send={{ key: activeTab }}>
                    <BonusTab on:addSpins={handleAddSpins} {isTelegramEnv} {authData} />
                </div>
            {:else if activeTab === 'tasks'}
                <div in:receive={{ key: activeTab }} out:send={{ key: activeTab }}>
                    <TasksTab on:addSpins={handleAddSpins} {isTelegramEnv} {authData} />
                </div>
            {/if}

      {/key}
  </main>

  <nav class="bottom-nav">
    <button class={activeTab === 'roulette' ? 'active' : ''} on:click={() => switchTab('roulette')}>
      <CasinoIcon />
      <span>Рулетка</span>
    </button>
    <button class={activeTab === 'friends' ? 'active' : ''} on:click={() => switchTab('friends')}>
      <PeopleIcon />
      <span>Друзья</span>
    </button>
    <button class={activeTab === 'bonus' ? 'active' : ''} on:click={() => switchTab('bonus')}>
      <GiftIcon />
      <span>Бонус</span>
    </button>
    <button class={activeTab === 'tasks' ? 'active' : ''} on:click={() => switchTab('tasks')}>
      <AssignmentIcon />
      <span>Задания</span>
    </button>
  </nav>
</div>

<style>

  @keyframes moveStars {
    from { transform: translate(0, 0); }
    to { transform: translate(-80px, -120px); }
  }


  .app-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background: radial-gradient(ellipse at bottom, #1B2735 0%, #090A0F 100%);
    position: relative;
    overflow-y: auto; 
    overflow-x: hidden;
    z-index: 1;
  }

 
  main {
    flex: 1;
    overflow-y: auto; 
     overflow-x: hidden;
    position: relative;
    z-index: 1;
    display: flex; 
    flex-direction: column;
  }

  .roulette-view, .placeholder-content {
     position: absolute;
     top: 0; left: 0; right: 0; bottom: 0;
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: space-around;
     padding: 10px 15px;
     overflow-y: auto; 
     overflow-x: hidden;
  }
  .roulette-view { justify-content: center; gap: 15px; }


  .roulette-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: clamp(10px, 3vh, 20px); 
  }

    .wheel-container {
        position: relative;
        width: min(78vw, 48vh);
        height: min(78vw, 48vh);
        max-width: 320px;
        max-height: 320px;
        margin: 0 auto;
    }

    .wheel {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        position: relative;
        overflow: hidden;
        transform: rotate(var(--wheel-rotation, 0deg));
        transition: box-shadow 0.3s ease;
        box-shadow: 0 0 40px rgba(0, 0, 0, 0.3);
    }

    .wheel-inner-shadow {
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        border-radius: 50%;
        box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.3);
        z-index: 2;
        pointer-events: none;
    }

    .wheel-highlight {
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        border-radius: 50%;
        background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 50%);
        z-index: 3;
        pointer-events: none;
    }

    .wheel-dividers {
        position: absolute;
        top: 0; left: 0; width: 100%; height: 100%;
        z-index: 4;
    }

    .wheel-divider {
        position: absolute;
        top: 0; left: 50%;
        width: 2px;
        height: 50%;
        background: rgba(0, 0, 0, 0.4);
        transform-origin: bottom center;
    }

.wheel-led-border {
    position: absolute;
    top: -15px; left: -15px; right: -15px; bottom: -15px;
    border-radius: 50%;
    background: none;
    z-index: 4;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.8);
    pointer-events: none;
    transform: rotate(var(--wheel-rotation, 0deg));
}

.led {
  --total: 24;
  --base-distance: 157px; /* базовое расстояние */
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  margin: -5px 0 0 -5px;
  border-radius: 50%;
  background: rgba(0, 255, 255, 1);
  box-shadow:
    0 0 8px rgba(0, 255, 255, 0.9),
    0 0 15px rgba(0, 255, 255, 0.6),
    0 0 30px rgba(0, 255, 255, 0.4);
  transform:
    rotate(calc(360deg / var(--total) * var(--i)))
    translate(0, calc(-100% - var(--led-distance, var(--base-distance))));
}

/* Одно медиа-правило с calc() для вычисления расстояния */
@media (max-width: 408px) {
  .led {
    --led-distance: calc(var(--base-distance) - (408px - min(408px, 100vw)) * 0.4);
  }
}

/* мерцание яркости */
@keyframes ledBlink {
  from { opacity: 0.8; filter: blur(1px); }
  to   { opacity: 1;   filter: blur(2px); }
}

    .wheel-center {
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        width: 18%; height: 18%;
        background: radial-gradient(circle at center, #FFD700, #FFA500);
        border-radius: 50%;
        z-index: 5;
        box-shadow: 0 0 10px rgba(255, 215, 0, 0.6);
        border: 2px solid rgba(0, 0, 0, 0.2);
    }

    .wheel-center-inner {
        position: absolute;
        top: 50%; left: 50%;
        transform: translate(-50%, -50%);
        width: 70%; height: 70%;
        background: radial-gradient(circle at center, #FFC125, #FF8C00);
        border-radius: 50%;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
    }

    .wheel-pointer-container {
        position: absolute;
        top: -14px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.6));
    }

    .wheel-pointer {
        width: 0; height: 0;
        border-left: 14px solid transparent;
        border-right: 14px solid transparent;
        border-top: 22px solid #00FFFF;
        position: relative;
    }

    .wheel-pointer::before { 
        content: '';
        position: absolute;
        top: -20px;
        left: -7px;
        width: 14px;
        height: 8px;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        transform: rotate(-25deg);
    }

    .segment-label-container {
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        transform: rotate(var(--angle));
        pointer-events: none;
        z-index: 4;
    }

    .segment-label {
        position: absolute;
        top: 25%;
        left: 50%;
        transform: translateX(-50%) rotate(-90deg);
        transform-origin: center center;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: clamp(14px, 3.5vw, 18px);
        font-weight: 600;
        white-space: nowrap;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    }

    .star-icon {
        font-size: 120%;
        margin-left: 2px;
        color: #FFD700;
        text-shadow: 0 0 4px rgba(255, 215, 0, 0.8);
    }

    .physical-prize {
        font-size: clamp(12px, 3vw, 16px);
        font-weight: 700;
    }

    .empty-segment {
        opacity: 0.8;
        font-size: clamp(16px, 4vw, 20px);
    }

  
  @keyframes spin { to { transform: rotate(360deg); } }


  .wheel-center-star {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 26%; height: 26%; 
  background: radial-gradient(ellipse at center, #1d3852 0%, #101a24 80%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  box-shadow: 
    0 0 25px rgba(110, 191, 255, 0.5),
    0 0 40px rgba(135, 195, 255, 0.3),
    inset 0 0 15px rgba(110, 191, 255, 0.2),
    inset 0 0 8px rgba(0, 0, 0, 0.6);
  border: 2px solid rgba(135, 195, 255, 0.5);
  animation: pulseCenter 3s infinite ease-in-out;
  overflow: hidden;
}



.center-star-shape {
  --star-color: #FFD700; 
  --glow-color: rgba(255, 215, 0, 0.8); 
  width: 85%;
  height: 85%;
  position: relative;
  animation: centerStarPulseGold 4s infinite ease-in-out;
}

.center-star-shape::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at center, rgba(255, 215, 0, 0.4) 0%, transparent 70%); 
  border-radius: 50%;
  animation: glowPulseGold 4s infinite alternate ease-in-out;
}


.wheel::before {
  content: '';
  position: absolute;
  top: -4px; right: -4px; bottom: -4px; left: -4px;
  border-radius: 50%;
  background: transparent;
  border: 2px solid rgba(135, 195, 255, 0.15);
  box-shadow: inset 0 0 20px rgba(135, 195, 255, 0.1);
  z-index: 0;
  pointer-events: none;
}

.wheel::after {
  content: '';
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  border-radius: 50%;
  background: radial-gradient(circle at center, transparent 55%, rgba(135, 195, 255, 0.07) 70%, transparent 75%);
  z-index: 1;
  pointer-events: none;
}

.segment-label {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%) rotate(-90deg);
  transform-origin: center center;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(17px, 3.9vw, 22px);
  font-weight: 700;
  white-space: nowrap;
  text-shadow: 
    0px 0px 5px rgba(0, 0, 0, 0.7),
    0px 0px 10px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
  z-index: 2;
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.3));
}

.segment-label :global(svg.prize-star-icon) {
  width: clamp(12px, 2.8vw, 15px);
  height: clamp(12px, 2.8vw, 15px);
  fill: currentColor;
  margin-left: 2px;
  vertical-align: middle;
  filter: drop-shadow(0 0 2px currentColor);
}

.physical-prize {
  font-size: clamp(14px, 3vw, 17px);
  font-weight: 700;
  text-shadow: 0 0 6px rgba(135, 195, 255, 0.8);
  filter: drop-shadow(0 0 2px rgba(135, 195, 255, 0.5));
}

.empty-segment {
  opacity: 0.8;
  font-size: clamp(21px, 4.5vw, 27px);
}

.wheel-pointer-container {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.6));
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  height: 35px;
}
.wheel-pointer {
  width: 0; height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-top: 22px solid #87C3FF; 
  position: relative;
  filter: drop-shadow(0 0 8px rgba(135, 195, 255, 0.6));
  transition: filter 0.3s ease;
}
.wheel-pointer::before { 
  content: ''; position: absolute; top: -20px; left: -7px;
  width: 14px; height: 8px; background: rgba(255, 255, 255, 0.8);
  border-radius: 50%; transform: rotate(-25deg);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
}
.wheel-pointer::after { 
  content: ''; position: absolute; top: 0px; left: -14px;
  width: 28px; height: 5px; background: rgba(0,0,0,0.2);
  clip-path: polygon(0 0, 100% 0, 70% 100%, 30% 100%);
}

    .wheel-inner-shadow {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      border-radius: 50%;
      box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.5);
      z-index: 2;
      pointer-events: none;
    }
    
    .wheel-highlight {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 50%);
      z-index: 3;
      pointer-events: none;
    }


@keyframes moveStars {
  from { transform: translate(0, 0); }
  to { transform: translate(-1000px, -1000px); }
}

.wheel-rim {
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    border-radius: 50%;
    border: 10px solid rgba(18, 32, 48, 0.9);
    box-shadow:
        inset 0 2px 5px rgba(135, 195, 255, 0.3),
        inset 0 -2px 5px rgba(0, 0, 0, 0.5),
        0 5px 15px rgba(0, 0, 0, 0.6);
    pointer-events: none;
    z-index: 5;
    transform: translateZ(2px);
}

.placeholder-content { justify-content: center; text-align: center; }
  .stars-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow-x: hidden; 
    overflow-y: auto;
    z-index: 0; 
  }

  .stars {
    display: block;
    background: transparent;
    background-repeat: repeat;
  }

 .stars1 { background-image: radial-gradient(1px 1px at 20px 30px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 40px 70px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 50px 160px, #C7D4DD, rgba(0,0,0,0)), radial-gradient(2px 2px at 90px 40px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 130px 80px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 160px 120px, #C7D4DD, rgba(0,0,0,0)); background-size: 200px 200px; animation-duration: 100s; opacity: 0.4; }
 .stars2 { background-image: radial-gradient(1px 1px at 10px 50px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 60px 90px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(2px 2px at 100px 150px, #C7D4DD, rgba(0,0,0,0)), radial-gradient(1px 1px at 140px 30px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 180px 100px, #9DB2BF, rgba(0,0,0,0)); background-size: 250px 250px; animation-duration: 150s; opacity: 0.5; }
 .stars3 { background-image: radial-gradient(2px 2px at 5px 5px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 80px 40px, #C7D4DD, rgba(0,0,0,0)), radial-gradient(1px 1px at 120px 180px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 170px 60px, #FFFFFF, rgba(0,0,0,0)); background-size: 300px 300px; animation-duration: 200s; opacity: 0.3; }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: rgba(10, 15, 20, 0.7); 
    backdrop-filter: blur(12px) saturate(150%);
    border-bottom: 1px solid rgba(110, 191, 255, 0.1); 
    z-index: 10;
    flex-shrink: 0;
    transition: background-color 0.3s ease;
  }

  .app-title {
    margin: 0;
    font-size: 1.45rem;
    font-weight: 700;
    background: linear-gradient(90deg, #87C3FF, #B4DFFF);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 10px rgba(135, 195, 255, 0.4);
  }

  .info-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    background-color: rgba(110, 191, 255, 0.1);
    border: 1px solid rgba(110, 191, 255, 0.15);
    border-radius: 20px;
    color: #A6C5E1;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.25s ease, color 0.25s ease, transform 0.2s ease;
  }
  .info-button:hover {
    background-color: rgba(110, 191, 255, 0.2);
    color: #FFFFFF;
    transform: scale(1.03);
  }
   .info-button :global(svg) { width: 17px; height: 17px; fill: currentColor; }


  .spin-button {
    margin-top: 5px;
    padding: 14px 30px; 
    font-size: 1.15rem;
    font-weight: 700;
    background: linear-gradient(45deg, #4A90E2, #61A6FF);
    border: none;
    border-radius: 50px;
    color: #FFFFFF;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 5px 12px rgba(86, 149, 236, 0.25), 0 2px 4px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-width: 200px; 
  }
  .spin-button:not(.disabled):hover {
    box-shadow: 0 7px 18px rgba(86, 149, 236, 0.35), 0 3px 6px rgba(0,0,0,0.2);
    transform: translateY(-3px);
    filter: brightness(1.1);
  }
  .spin-button:not(.disabled):active {
    transform: translateY(0px);
    box-shadow: 0 3px 8px rgba(86, 149, 236, 0.2), 0 1px 2px rgba(0,0,0,0.1);
    filter: brightness(0.95);
  }
  .spin-button.disabled {
    background: linear-gradient(45deg, #546E7A, #78909C);
    cursor: not-allowed;
    box-shadow: none;
    color: #B0BEC5;
    opacity: 0.7;
  }
  .spinner {
    width: 18px; height: 18px; border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff; border-radius: 50%; animation: spin 1s linear infinite;
  }

  .result-container {
    text-align: center;
    margin-top: 5px;
    padding: 12px 18px;
    background-color: rgba(10, 15, 20, 0.85); 
    backdrop-filter: blur(8px);
    border-radius: 15px;
    border: 1px solid rgba(110, 191, 255, 0.1);
    width: 90%;
    max-width: 340px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    z-index: 5; 
  }

.result-text {
    margin: 0 0 12px 0;
    font-size: 1.1rem;
    color: #E1E9F0;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;  
    gap: 5px;
    flex-wrap: nowrap;
    line-height: 1.5;
  }

  .result-value { font-weight: 700; font-size: 1.3rem; }
  .result-value.stars { color: #FFA000; }
  .result-value.physical { color: #87C3FF; }
  .result-value.zero { color: #90A4AE; }
  .result-value :global(svg.prize-star-icon) {
      width: 1.1em; height: 1.1em; fill: currentColor; margin-left: 3px; vertical-align: -0.15em;
  }

  .claim-button, .retry-button {
    padding: 9px 20px;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: 5px;
  }
  .claim-button { background: linear-gradient(45deg, #4A90E2, #61A6FF); color: #fff; box-shadow: 0 3px 7px rgba(86, 149, 236, 0.25); }
  .claim-button.physical { background: linear-gradient(45deg, #87C3FF, #B4DFFF); color: #1A1A1A; }
  .retry-button { background-color: rgba(110, 191, 255, 0.15); color: #A6C5E1; }
  .retry-button:hover { background-color: rgba(110, 191, 255, 0.25); color: #FFF; }
  .retry-button:disabled { background-color: rgba(84, 110, 122, 0.2); color: #78909C; cursor: not-allowed; opacity: 0.7; }


  .spin-count {
    margin-top: 5px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px 15px;
    background-color: rgba(10, 15, 20, 0.7);
    border-radius: 20px;
    border: 1px solid rgba(110, 191, 255, 0.08);
    transition: opacity 0.3s ease;
  }
  .remaining-text { font-size: 0.9rem; color: #A6C5E1; opacity: 0.8; }
  .count-value { font-size: 1.15rem; font-weight: bold; color: #87C3FF; }


  .rules-modal {
    position: fixed; inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    backdrop-filter: blur(6px);
  }
  .rules-content {
    background: linear-gradient(160deg, #1A2430, #101820);
    width: 88%;
    max-width: 400px;
    border-radius: 18px;
    padding: 25px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(110, 191, 255, 0.1);
  }
  .rules-content h2 { margin-top: 0; margin-bottom: 20px; color: #87C3FF; text-align: center; font-size: 1.5rem; font-weight: 700; }
  .rules-content ul { padding-left: 20px; margin-bottom: 25px; color: #D0DCE8; font-size: 0.98rem; }
  .rules-content li { margin-bottom: 12px; line-height: 1.6; }
  .close-button { width: 100%; padding: 12px; font-size: 1rem; font-weight: 600; background: linear-gradient(45deg, #4A90E2, #61A6FF); border: none; border-radius: 50px; color: #fff; cursor: pointer; transition: all 0.3s ease; }
  .close-button:hover { filter: brightness(1.1); transform: scale(1.02); }


  .placeholder-content { color: #A6C5E1; padding: 2rem; }
  .placeholder-icon { margin-bottom: 20px; }
  .placeholder-icon :global(svg) {
      width: clamp(55px, 16vw, 75px); height: clamp(55px, 16vw, 75px);
      fill: #6EBFFF; 
      filter: drop-shadow(0 0 10px rgba(110, 191, 255, 0.3));
  }
  .placeholder-content h2 { color: #E1E9F0; margin-bottom: 1rem; font-size: 1.4rem; font-weight: 700; }
  .placeholder-content p { font-size: 1rem; line-height: 1.5; opacity: 0.9; }


  .bottom-nav {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    padding: 6px 0;
    background-color: rgba(10, 15, 20, 0.8); 
    backdrop-filter: blur(15px) saturate(180%);
    border-top: 1px solid rgba(110, 191, 255, 0.1);
    z-index: 10;
    flex-shrink: 0;
    position: relative; 
  }

  .bottom-nav::before {
      content: '';
      position: absolute;
      top: -1px;
      left: calc(var(--active-tab-index, 0) * 25%);
      width: 25%;
      height: 2px;
      background-color: #87C3FF; 
      transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1); 
      box-shadow: 0 0 5px rgba(135, 195, 255, 0.7);
  }

  .bottom-nav button {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px 0;
    background: transparent;
    border: none;
    color: #8A9FB3; 
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.3s ease, transform 0.2s ease;
    position: relative;
    z-index: 1;
  }
  .bottom-nav button :global(svg) { width: 23px; height: 23px; transition: fill 0.3s ease, transform 0.2s ease; }
  .bottom-nav button:hover { color: #BDD1E6; }
  .bottom-nav button.active { color: #87C3FF; }
  .bottom-nav button:active { transform: scale(0.95); }
  .bottom-nav button.active :global(svg) { transform: scale(1.1); }

  .bottom-nav button:nth-child(1).active ~ ::before { --active-tab-index: 0; }
  .bottom-nav button:nth-child(2).active ~ ::before { --active-tab-index: 1; }
  .bottom-nav button:nth-child(3).active ~ ::before { --active-tab-index: 2; }
  .bottom-nav button:nth-child(4).active ~ ::before { --active-tab-index: 3; }

.wheel.spinning {
   box-shadow:
     0 0 50px rgba(0, 0, 0, 0.8),
     0 0 80px rgba(110, 191, 255, 0.3),
     inset 0 0 40px rgba(110, 191, 255, 0.2),
     inset 0 0 15px rgba(0, 0, 0, 0.6),
     0 0 20px 10px #17a2b8;
}

 .stars-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1; 
  }

  .stars {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: block;
    background: transparent; 
    background-repeat: repeat;
    background-size: cover; 
    animation: moveStars 15000s linear infinite alternate;
  }

    .stars-stars {

    display: block;
    background: transparent; 
    background-repeat: repeat;
    background-size: cover; 
    animation: moveStars 15000s linear infinite alternate;
  }

    .prize-modal {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
    backdrop-filter: blur(10px);
  }
  
  .prize-content {
    background: linear-gradient(145deg, #1A2430, #0c1218);
    width: 90%;
    max-width: 420px;
    border-radius: 24px;
    padding: 30px 25px;
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.7),
                0 0 120px rgba(77, 171, 247, 0.25);
    border: 1px solid rgba(110, 191, 255, 0.15);
    position: relative;
    overflow: hidden;
  }
  
  .prize-header {
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    z-index: 2;
  }
  
  .prize-stars-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    color: #FFD700;
    font-size: 2.5rem;
  }
  
  .prize-header h2 {
    color: #87C3FF;
    font-size: 2rem;
    font-weight: 700;
    margin: 0;
    background: linear-gradient(90deg, #87C3FF, #E1F0FF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(135, 195, 255, 0.4);
  }
  
  .prize-body {
    text-align: center;
    margin-bottom: 25px;
    position: relative;
    z-index: 2;
  }
  
  .prize-amount {
    font-size: 3.5rem;
    font-weight: 800;
    color: #FFD700;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-shadow: 0 0 15px rgba(255, 215, 0, 0.6);
  }
  
  .prize-message {
    color: #ffffff;
    font-size: 1.25rem;
    margin-bottom: 15px;
  }
  
  .prize-glow {
    position: absolute;
    top: -100px;
    left: -100px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(135, 195, 255, 0.4) 0%, rgba(135, 195, 255, 0) 70%);
    border-radius: 50%;
    animation: float 6s ease-in-out infinite;
    z-index: 1;
    opacity: 0.6;
  }
  
  .prize-actions {
    position: relative;
    z-index: 2;
  }
  
  .claim-prize-button {
    width: 100%;
    padding: 16px;
    font-size: 1.2rem;
    font-weight: 600;
    background: linear-gradient(45deg, #FF9800, #FF5722);
    border: none;
    border-radius: 50px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    box-shadow: 0 5px 15px rgba(255, 87, 34, 0.3);
  }
  
  .arrow-icon {
    margin-left: 10px;
    font-size: 1.4rem;
  }
  
  .claim-prize-button:hover {
    filter: brightness(1.1);
    transform: translateY(-2px);
    box-shadow: 0 7px 20px rgba(255, 87, 34, 0.4);
  }
  
  .claim-prize-button:active {
    transform: translateY(1px);
  }
  
  .prize-terms {
    text-align: center;
    color: #D0DCE8;
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0;
  }
  
  .prize-small-text {
    font-size: 0.8rem;
    opacity: 0.7;
  }
  
  .modal-close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: rgba(255, 255, 255, 0.7);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 5;
  }
  
  .modal-close-button:hover {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
  }
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-20px) rotate(10deg);
    }
  }
  
  /* Make prize icon in modal larger */
  .prize-stars-icon :global(svg) {
    width: 48px;
    height: 48px;
    color: #FFD700;
  }
  
  /* Style for the prize icon inside the amount */
  .prize-amount :global(svg) {
    width: 40px;
    height: 40px;
    margin-left: 8px;
    color: #FFD700;
  }
</style>